export default {
  reviews: state => {
    return state.reviews
  },
  loading: state => {
    return state.loading
  }
}
